import { blocksCart } from "@/lib/agenda";
import { dateLabel, isCovered, useAgenda } from "@/lib/agendaStore";
import { Bow } from "./Decor";

const strip = { backgroundImage: "linear-gradient(rgba(250,247,242,.9),rgba(250,247,242,.9)), url(/img/agenda/vichy-lacos-640.webp)", backgroundSize: "auto, 320px" };

const Box = ({ tone, children, className, testId }) => (
  <aside
    data-testid={testId}
    role={tone === "closed" ? "status" : undefined}
    className={`flex items-start gap-3 rounded-2xl px-3.5 py-3 text-[13.5px] leading-snug text-ink ring-1 ${tone === "closed" ? "bg-rose-soft ring-bordeaux/25" : "ring-bordeaux/10"} ${className}`}
    style={tone === "closed" ? undefined : strip}
  >
    <Bow className="mt-0.5 h-5 w-6 shrink-0" />
    <div className="space-y-1">{children}</div>
  </aside>
);

/**
 * Indicador discreto da agenda de Natal nas páginas de produto, carrinho e pagamento: o prazo previsto e o estado.
 * `slugs`: as peças em causa. Quando a loja não aceita encomendas com elas, diz porquê.
 */
export function AgendaNote({ slugs, className = "" }) {
  const agenda = useAgenda();
  if (!agenda) return null;
  if (agenda.suspended) return <Box tone="closed" className={className} testId="agenda-note-suspended"><p>{agenda.suspendedMessage}</p></Box>;
  if (blocksCart(agenda, slugs)) return <Box tone="closed" className={className} testId="agenda-note-closed"><p>{agenda.closedMessage}</p></Box>;
  if (!agenda.visible || !isCovered(agenda, slugs)) return null;
  const until = agenda.closesAt ? dateLabel(agenda.closesAt) : null;
  return (
    <Box tone="open" className={className} testId="agenda-note">
      <p>
        <strong className="font-semibold">Feito especialmente para ti ♡</strong>
        {agenda.deliveryText && <> Prazo previsto: <span data-testid="agenda-note-delivery">{agenda.deliveryText}</span>.</>}
      </p>
      {agenda.status === "almost" ? (
        <p className="text-bordeaux" data-testid="agenda-note-almost">{agenda.almostMessage}</p>
      ) : agenda.closingSoon && until ? (
        <p className="text-bordeaux" data-testid="agenda-note-soon">A agenda de Natal fecha a {until}. Encomenda com antecedência ♡</p>
      ) : until ? (
        <p className="text-taupe-strong">Agenda de Natal aberta até {until}.</p>
      ) : null}
    </Box>
  );
}

/** Aviso em todas as páginas quando a Alexandra suspende as novas encomendas: a loja continua a poder ser vista. */
export function ShopNotice() {
  const agenda = useAgenda();
  if (!agenda?.suspended) return null;
  return (
    <div className="relative z-10 text-ink" style={strip} role="status" data-testid="shop-suspended-notice">
      <div className="bb-container flex items-center justify-center gap-3 py-2.5 text-center text-[12.5px] leading-snug sm:text-[13.5px]">
        <Bow className="hidden h-5 w-6 shrink-0 sm:block" />
        <p>{agenda.suspendedMessage}</p>
      </div>
    </div>
  );
}
